const COPY_LINK_TYPE = 'link';
const COPY_CONTENT_TYPE = 'content';
const SEND_EMAIL_TYPE = 'email';

export { COPY_LINK_TYPE, COPY_CONTENT_TYPE, SEND_EMAIL_TYPE };
